import { render, staticRenderFns } from "./CartIcon.vue?vue&type=template&id=34771f81&scoped=true"
import script from "./CartIcon.vue?vue&type=script&lang=ts"
export * from "./CartIcon.vue?vue&type=script&lang=ts"
import style0 from "./CartIcon.vue?vue&type=style&index=0&id=34771f81&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "34771f81",
  null
  
)

export default component.exports